import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AccountGroup } from '../../../../core/model/account-group/account-group.model';

/**
 * Presentational component - displays list of account groups.
 *
 * Emits two events (chained from child components):
 * - onAccountGroupClick - toggle account group visibility
 * - onProductEnableToggle - toggle product enabled status
 */
@Component({
    selector: 'ssf-accounts-groups',
    template: require('./accounts-groups.component.html'),
    styles: [require('./accounts-groups.component.scss')]

})
export class AccountsGroupsComponent implements OnInit, OnChanges {
    public i18n = 'SHARED.ACCOUNTS-GROUPS.';

    @Input() accountsGroups: AccountGroup[];

    @Output() onAccountGroupClick = new EventEmitter();
    @Output() onProductEnableToggle = new EventEmitter();

    ngOnInit(): void {
        if (this.accountsGroups) {
            this.accountsGroups = this.filterAccountGroups(this.accountsGroups);
        }
    }

    ngOnChanges(): void {
        this.accountsGroups = this.filterAccountGroups(this.accountsGroups);
    }

    filterAccountGroups(accountsGroups: AccountGroup[]) {
        // display only account group that has at least one product - http://youtrack.csin.cz/issue/SSF-212
        return accountsGroups
            ? accountsGroups.filter(group => group.products  &&  group.products.length > 0)
            : [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/accounts-groups/accounts-groups.component.ts